module.exports = {
    InitialAccountDataStorageKey: "intitialAccountData",
    CreateHQDataStorageKey: "createHQData",
    StaffPermissionsLevelStorageKey: "staffPermissionsLevel",
    DeviceTypeStorageKey: "deviceTypeStorageKey",
    SeatCountStorageKey: "seatCount",
    AutomationCompleted: "automationCompleted",
    DefaultRegionStorageKey: "DefaultRegion"
};
